
export const SELECTED_VENUE_ID = "SELECTED_VENUE_ID";


export function selectedVenueIdReducer(state = "", action: { type: string, payload: string }) {
    switch (action.type) {
        case SELECTED_VENUE_ID:
            const venueId = action.payload;
            state = venueId;
            return state;
        default:
            return state;
    }
}